// rx to detect all special characters
export const noSpecialChars = (str: string) => {
  return !/[~`!@#$%\^&()_*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str);
};
